import { useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import { Table } from '@tiptap/extension-table';
import { TableRow } from '@tiptap/extension-table-row';
import { TableHeader } from '../extensions/TableHeader';
import { TableCell } from '../extensions/TableCell';
import { TableCellBackground } from '../extensions/TableCellBackground';
import { TextStyle } from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';
import { Highlight } from '@tiptap/extension-highlight';
import Link from '@tiptap/extension-link';
import { TextAlign } from '@tiptap/extension-text-align';
import { TaskList } from '@tiptap/extension-task-list';
import { TaskItem } from '@tiptap/extension-task-item';
import { marked } from 'marked';
import { useEffect } from 'react';
interface UseWysiwygEditorProps {
  content: string;
  onChange: (content: string) => void;
  editable: boolean;
}
marked.use({
  gfm: true,
  breaks: false
});
export const useWysiwygEditor = ({ content, onChange, editable }: UseWysiwygEditorProps) => {
  return useEditor({
    extensions: [
      StarterKit,
      Placeholder.configure({
        placeholder: 'Start writing your content...'
      }),
      Table.configure({
        resizable: true
      }),
      TableRow,
      TableHeader,
      TableCell,
      TableCellBackground,
      TextStyle,
      Color,
      Highlight.configure({
        multicolor: true
      }),
      Link.configure({
        openOnClick: false,
        autolink: true,
        linkOnPaste: true
      }),
      TextAlign.configure({
        types: ['heading', 'paragraph']
      }),
      TaskList,
      TaskItem
    ],
    content: marked(content),
    editable: editable,
    onUpdate: ({ editor }) => {
      const html = editor.getHTML();
      onChange(html);
    }
  });
};
